module.exports = __webpack_public_path__ + "1a481db94ee0f4e835fbd3492299269e.png";